import React from 'react';
import CategoryInsights from './CategoryInsights';

const MarketResearch = () => {
  return (
    <CategoryInsights
      category="market-research"
      titleKey="pages.marketResearch.title"
      subtitleKey="pages.marketResearch.subtitle"
      categoryLabelKey="insights.marketResearch"
    />
  );
};

export default MarketResearch;
